import { useState } from 'preact/hooks'
import { FieldLabel } from './FieldLabel'

const Switch = ({ isSelected }) => {
  return (
    <div
      className={`relative h-fit w-11 cursor-pointer rounded-3xl  transition-colors ${
        isSelected ? 'bg-secondary-green' : 'bg-neutrals-medium-grey'
      } `}
    >
      {' '}
      <div
        style="--x-80:83%;"
        className={`h-6 w-6 rounded-full border-2 border-solid bg-primary-white transition-all ${
          isSelected ? 'translate-x-[--x-80] border-secondary-green' : 'border-neutrals-medium-grey'
        }`}
      ></div>
    </div>
  )
}

export const FieldSwitch = ({ name, required, value, label, onChange, options }) => {
  const isActive = value === true || value === 'true'

  return (
    <div className={'flex w-full flex-col gap-2'}>
      <FieldLabel {...{ label, hasInput: !!value, required }} />
      <div className={'flex flex-row gap-4'}>
        {options.map((o) => {
          return (
            <div
              className={`relative w-full overflow-hidden rounded-lg border border-solid border-neutrals-tertiary-grey bg-primary-white transition-colors
          ${isActive ? 'border-2 border-secondary-green' : 'border-neutrals-tertiary-grey'}`}
            >
              <div className={'flex flex-row justify-between gap-2 p-4'}>
                <input
                  value={value}
                  name={name}
                  onChange={(e) => {
                    e.currentTarget.value = !value
                    onChange(e)
                  }}
                  checked={isActive}
                  type="checkbox"
                  className={'absolute inset-0 z-10 h-full w-full cursor-pointer appearance-none opacity-0 '}
                />
                <div className={'paragraph-sm my-auto font-bold'}>
                  {o.label}
                  {required && '*'}
                </div>
                <Switch isSelected={isActive} />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
